var React = require('react');

function More (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"strokeOpacity":".012","stroke":"#000","strokeWidth":"0","d":"M0 0h32v32H0z","key":0}),React.createElement("g",{"stroke":"#738A94","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("path",{"d":"M7.333 16c0 2.222-1.11 3.333-3.333 3.333-2.222 0-3.333-1.11-3.333-3.333 0-2.222 1.11-3.333 3.333-3.333 2.222 0 3.333 1.11 3.333 3.333zM19.333 16c0 2.222-1.11 3.333-3.333 3.333-2.222 0-3.333-1.11-3.333-3.333 0-2.222 1.11-3.333 3.333-3.333 2.222 0 3.333 1.11 3.333 3.333zM31.333 16c0 2.222-1.11 3.333-3.333 3.333-2.222 0-3.333-1.11-3.333-3.333 0-2.222 1.11-3.333 3.333-3.333 2.222 0 3.333 1.11 3.333 3.333z"}))]));
}

More.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = More;

More.default = More;
